export default __webpack_public_path__ + "static/media/PlutexSwap02.44870649.png";